module.exports = __webpack_public_path__ + "img/consulta-trastorno.c63dd070.jpg";